import Reveal from '@/components/base/Reveal';
import { readingPath } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function PathSection() {
  return (
    <section id="path" className="scroll-mt-16 bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Reading Path"
            title="阅读脉络：故事大致这样展开"
            desc="长篇幅作品如果缺少整体脉络，读起来容易失去方向。下面把故事常见的推进过程拆成五个阶段，帮助你把握每个部分的大致重点。"
          />
        </Reveal>

        <div className="mt-10 relative">
          <div className="absolute left-[19px] md:left-1/2 top-2 bottom-2 w-px bg-background-300 md:-translate-x-1/2" />
          <ol className="space-y-4 md:space-y-6">
            {readingPath.map((stage, index) => (
              <li key={stage.stage} className="relative">
                <Reveal delay={index * 60}>
                  <div
                    className={`flex items-start gap-4 md:gap-8 ${
                      index % 2 === 1 ? 'md:flex-row-reverse md:text-right' : ''
                    }`}
                  >
                    <span className="relative z-10 w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg md:mx-0">
                      <i className={stage.icon} />
                    </span>
                    <div className="flex-1 rounded-lg bg-background-50 border border-background-200 p-5">
                      <span className="text-xs font-label tracking-widest uppercase text-accent-700">
                        {stage.stage}
                      </span>
                      <h3 className="mt-1 font-heading text-base md:text-lg font-semibold text-foreground-900">
                        {stage.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">{stage.desc}</p>
                    </div>
                    <div className="hidden md:block flex-1" aria-hidden="true" />
                  </div>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}